import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M512 1024A512 512 0 0115.36 388.267 512 512 0 01950.613 248.32a508.16 508.16 0 0158.027 387.413A512 512 0 01512 1024zm0-998.4a486.4 486.4 0 00-117.76 958.293A486.4 486.4 0 00983.893 629.76 486.4 486.4 0 00629.76 40.107 488.96 488.96 0 00512 25.6zm-42.667 276.053l-16.64 44.8V618.24a102.4 102.4 0 01-42.666 74.667 121.173 121.173 0 01-81.067 33.706 80.213 80.213 0 01-37.547-8.96 89.173 89.173 0 01-29.44-24.32 112.64 112.64 0 01-18.773-37.12 160.853 160.853 0 01-6.4-47.36 251.307 251.307 0 0111.52-74.666A143.787 143.787 0 01258.987 512c2.56-4.693 4.693-7.253 6.4-7.253s0 8.533 0 15.36 0 14.08-2.56 21.333 0 14.507-2.56 21.333 0 11.947 0 15.787a101.973 101.973 0 0026.026 77.653 82.773 82.773 0 0055.04 26.454 52.907 52.907 0 0023.04-5.974 107.52 107.52 0 0023.04-14.933 122.027 122.027 0 0019.627-21.333 106.667 106.667 0 0013.653-24.747V322.56l-8.533-57.173 36.267-46.08 3.413 55.466zm213.334 264.96q0 46.934-10.667 46.507H563.627a88.747 88.747 0 01-35.84-5.973 39.253 39.253 0 01-20.054-19.2 117.333 117.333 0 01-6.4-46.507V264.107l32.854-50.774V541.44q0 19.627 14.506 19.627h99.84s2.987-2.134 2.987-7.254a68.267 68.267 0 00-2.56-15.36q-2.56-10.24-6.4-20.053a118.187 118.187 0 00-8.107-17.493c-2.986-5.12-5.12-7.254-7.253-7.254l18.773-56.32q13.227 7.254 24.747 58.88a337.067 337.067 0 0111.947 70.4zm-131.84 259.84l15.36-39.68 42.666 33.707-17.066 38.827zm33.706-143.786zm203.947-98.134a170.667 170.667 0 01-42.667 117.334 103.253 103.253 0 01-72.533 42.666q-42.667 0-85.333-73.386a42.667 42.667 0 009.386 11.52 179.2 179.2 0 0021.334 8.96 143.787 143.787 0 0020.053 5.546 96 96 0 0017.493 0q69.974 0 110.08-94.293a42.667 42.667 0 002.56-13.653 104.96 104.96 0 00-42.666-75.52l20.053-50.774a85.333 85.333 0 0119.2 21.334 156.587 156.587 0 0114.933 29.866 198.4 198.4 0 019.387 34.987 206.507 206.507 0 01-.853 37.12zm-136.96 268.8L608.853 819.2l16.214-36.267 42.666 32.427z"
});

function SvgIrr(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "IRR_svg__icon",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrr);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'IRROutlined';

export default KuFoxIcons;
